/* eslint-disable no-use-before-define */
import { css } from '@linaria/core';
import theme from '../../../theme';
import { spinner } from '../../atoms/spinner/spinner.styles';
import * as iconStyles from '../../atoms/icon/icon.styles';
import { input } from '../input/input.styles';

const iconClass = `.${iconStyles.icon}`;

export const variants = {
  interactive: css``,
  success: css``,
  warning: css``,
  error: css``,
  default: css``,
  hasAddons: css``,
  gapless: css``,
  right: css``,
  left: css``,
};

export const control = css`
  --height: var(--control-height, 36px);
  height: var(--height);
  position: relative;
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
  &:has(textarea) {
    height: auto;
  }

  & .${spinner} {
    width: 1.25rem;
    height: 1.25rem;
  }

  & .${iconStyles.icon} {
    pointer-events: none;
  }

  & .${iconStyles.icon}.${iconStyles.variants.interactive} {
    pointer-events: unset;
  }

  &[disabled] .${iconStyles.icon} {
    color: ${theme.colors.neutral['60']};
  }

  &.${variants.success} .${iconStyles.icon} {
    color: ${theme.colors.success['80']};
  }

  &.${variants.warning} .${iconStyles.icon} {
    color: ${theme.colors.warning['80']};
  }

  &.${variants.error} .${iconStyles.icon} {
    color: ${theme.colors.error['80']};
  }

  &.${variants.gapless} {
    gap: 0;
    & *:focus {
      outline: none;
    }
    & > * {
      height: var(--height);
      margin-right: 0;
      box-shadow: none;
      &:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        &.${control} > * {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
      &:not(:last-child) {
        border-right-width: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &.${control} > * {
          border-right-width: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
  }

  &:has(${iconClass}) {
    & > .${iconStyles.icon} {
      position: absolute;
      width: calc(var(--height) - 2px);
      height: calc(var(--height) - 2px);
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      background: transparent !important;
      &:last-of-type {
        right: 1px;
        top: 1px;
      }
      &:first-child {
        left: 1px;
        top: 1px;
        right: initial;
      }
    }
    &:has(${iconClass}:last-child) {
      & .${input} {
        padding-right: var(--height);
      }
    }

    &:has(${iconClass}:first-child) {
      & .${input} {
        padding-left: var(--height);
      }
    }
  }
`;

// , & .${textarea}
